import type { ReactNode } from 'react';

export function ToggleTile({
  icon,
  label,
  checked,
  disabled,
  onChange,
}: {
  icon: ReactNode;
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`btn-press flex flex-col items-center gap-2 rounded-2xl border px-3 py-3 transition-colors ${
        checked
          ? 'border-accent/40 bg-accent/10 text-white'
          : 'border-white/10 bg-white/[0.03] text-zinc-500 hover:border-white/15'
      } disabled:opacity-50`}
    >
      <span className={checked ? 'text-accent' : 'text-zinc-500'}>{icon}</span>
      <span className="text-[11px] font-semibold">{label}</span>
    </button>
  );
}
